import React from "react";
import PolicyPage, { ContactEmail } from "./PolicyPage";

function SubscriptionPolicy() {
  return (
    <PolicyPage title="Subscription Policy">
      <p>This policy applies only when a product is clearly offered as a recurring subscription or prepaid multi-delivery plan.</p>

      <h2>Plan details</h2>
      <p>The product page or checkout will state the price, billing frequency, delivery frequency, minimum term, contents or selection method, and whether the plan renews automatically. One-time purchases do not become subscriptions unless you affirmatively choose a recurring option.</p>

      <h2>Recurring authorization</h2>
      <p>For an auto-renewing plan, you authorize charges to the selected payment method at the disclosed frequency until cancellation. Taxes, shipping, and permitted price changes may affect future totals. We will give notice of material changes where required by law.</p>

      <h2>Renewal, cancellation, and pauses</h2>
      <p>Cancellation instructions and any applicable cutoff appear with the plan or in your account. You may also email us. Requests received after an order has entered fulfilment apply to the next renewal, and the current shipment remains chargeable unless law provides otherwise. Pause, skip, or reschedule features are available only when expressly offered.</p>

      <h2>Failed payments</h2>
      <p>If a renewal payment fails, we may retry it, ask you to update the method, pause fulfilment, or cancel the plan. We do not charge a separate failed-payment fee, though your bank may.</p>

      <h2>Prepaid and gift subscriptions</h2>
      <p>Prepaid plans ordinarily end after the stated number of deliveries unless renewal was clearly selected. The purchaser is responsible for accurate recipient information. Changes may be limited after a delivery is scheduled.</p>

      <h2>Perishable goods and returns</h2>
      <p>Perishable subscription shipments generally cannot be returned for change of mind. Contact us promptly about damage, quality, or an incorrect item. Statutory rights remain unaffected.</p>

      <h2>Contact</h2>
      <p>Include the subscription or order number when emailing <ContactEmail />.</p>
    </PolicyPage>
  );
}

export default SubscriptionPolicy;
